import Vue from 'vue';
import Vuex from 'vuex';
import main from './main';
import _ from 'lodash';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main,
  },
  state: {
  	offset: 0,
    scrolledHeader: false,
    scrollTo: false,
    animLayerState: null,
    mode: false,
    servicesLocations: 'null',
    popUpInfo: null,
    silkCategories: null,
    silkSelectedCategory: null,
    selectedPackage: null,
    filteredLocations: null,
  },
  getters:{
  	getOffest: (state) => state.offset,
    getScrolledHeader: (state) => state.scrolledHeader,
    getScrollToTop: (state) => state.scrollTo,
    getAnimLayerState: (state) => state.animLayerState,
    getServicesLocations: (state) => state.servicesLocations,
    getPoupUpInfo: (state) => state.popUpInfo,
    getSilkCategories: (state) => state.silkCategories,
    getSilkSelectedCategory: (state) => state.silkSelectedCategory,
    getSelectedPackage: (state) => state.selectedPackage,
    getFilteredLocations: (state) => state.filteredLocations,
  },
  mutations:{
  	setState : function (state, data) {
      if (! data.key) return false;
      Vue.set(state, data.key, data.val);
    },
    setHeaderState : function(state, payload){
      state.scrolledHeader = payload;
    },
    setScrollTo: function(state, payload){
      state.scrollTo = payload;
    },
    setAnimLayerState: function(state, payload){
      state.animLayerState = payload;
    },
    setMode: function(state, payload){
      state.mode = payload;
    },
    setServicesLocations(state,payload){
      state.servicesLocations = payload;
    },
    setPopupInfo(state,payload){
      state.popUpInfo = payload;
    },
    setSilkCategories(state,payload){
      state.silkCategories = payload;
    },
    setSilkSelectedCategory(state,payload){
      state.silkSelectedCategory = payload;
    },
    setSelectedPackage(state,payload){
      state.selectedPackage = payload;
    },
    setFilteredLocations(state,payload){
      state.filteredLocations = payload;
    }
  }
});
